<template lang="pug">
v-card(flat)
  v-card-title Изменить пароль
  v-card-text
    api-form(
      v-model="formData"
      :fields="components"
      :method="save"
      :autosave="false"
      :defaultAttrs="{filled: true,rounded: true}"
      :btn-props="{ rounded: true, color: 'success' }"
    )
</template>
<script>

export default {
  data() {
    return {
      showPassword: {
        old: false,
        new: false,
        confirm: false,
      },
      formData: {},
    };
  },
  computed: {
    components() {
      return [
        {
          text: 'Текущий пароль',
          value: 'old_password',
          rules: 'required',
          component: 'v-text-field',
          component_attrs: {
            type: this.showPassword.old ? 'text' : 'password',
            appendIcon: this.showPassword.old ? 'mdi-eye' : 'mdi-eye-off',
          },
          component_events: {
            'click:append': () => { this.showPassword.old = !this.showPassword.old; },
          },
        },
        {
          text: 'Новый пароль',
          value: 'new_password',
          rules: 'required',
          component: 'v-text-field',
          component_attrs: {
            type: this.showPassword.new ? 'text' : 'password',
            appendIcon: this.showPassword.new ? 'mdi-eye' : 'mdi-eye-off',
          },
          component_events: {
            'click:append': () => { this.showPassword.new = !this.showPassword.new; },
          },
        },
        {
          text: 'Повторите новый пароль',
          value: 'new_password_confirmation',
          rules: 'required|confirmed:new_password',
          component: 'v-text-field',
          component_attrs: {
            type: this.showPassword.confirm ? 'text' : 'password',
            appendIcon: this.showPassword.confirm ? 'mdi-eye' : 'mdi-eye-off',
          },
          component_events: {
            'click:append': () => { this.showPassword.confirm = !this.showPassword.confirm; },
          },
        },
      ];
    },
  },
  methods: {
    save({ data, obs }) {
      return this.$rHandler(
        this.$api.auth.changePassword(data),
        () => { this.$toasted.success('Успешно'); },
        (resp) => resp,
        obs,
      );
    },
  },
};
</script>
